import { isAxiosError } from "axios";
import { FieldPath, UseFormSetError } from "react-hook-form";
import { t } from "i18next";

import { toast } from "@/utils/customToast";

export default function errorHandler<TApiErrorKeyName extends string>(error: any) {
  if (error.response.status === 429) {
    toast.error(t("auth:error.tooManyAttempts"));
  }
  if (
    isAxiosError<{ errors?: { [key in TApiErrorKeyName]?: string[] } }>(error) &&
    error.response?.data.errors
  ) {
    return error.response.data.errors;
  }
}

/**
 *
 * @param apiErrors - errors object returned by the errorHandler function
 * @param setError - function returned by the useForm hook
 * @param fieldNameToApiErrorKeyMapping - object which key name is a form field name, and value is api error key name; for example { firstName: "first_name" }
 *
 */
export function assignApiErrorsToFormFields<
  TApiErrors extends { [key: string]: string[] },
  TFormValues extends {},
>(
  apiErrors: TApiErrors | undefined,
  setError: UseFormSetError<TFormValues>,
  fieldNameToApiErrorKeyMapping: Partial<{ [key in FieldPath<TFormValues>]: keyof TApiErrors }>,
) {
  if (!apiErrors) return;

  const fieldNames = Object.keys(fieldNameToApiErrorKeyMapping) as FieldPath<TFormValues>[];

  if (fieldNames.length === 0) return;

  fieldNames.forEach((fieldName) => {
    const apiErrorKeyName = fieldNameToApiErrorKeyMapping[fieldName];

    if (apiErrorKeyName && apiErrors[apiErrorKeyName]) {
      const errorMessage = apiErrors[apiErrorKeyName][0];

      setError(fieldName, { message: errorMessage });
    }
  });
}
